// @flow
import {connect} from 'react-redux';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {
  goToSignUp,
  goToSimActivation,
} from '../../../modules/Navigation/actions';
import NoPendingDeliveryPanel from './NoPendingDeliveryPanel';

import type {DispatchProps} from './NoPendingDeliveryPanel';
import type {StateProps} from './NoPendingDeliveryPanel';
import type {State} from '../../../modules/reducers';
import {voucherFilteredAvailableVouchersSelectorLazy} from '../../../modules/Voucher';

const mapStateToProps = (state: State): StateProps => ({
  isInitializingSignUp: isLoadingSelector(state, 'initSignUp'),
  filteredAvailableVouchers:
    voucherFilteredAvailableVouchersSelectorLazy(state),
});

const mapDispatchToProps: DispatchProps = {
  goToSignUp,
  goToSimActivation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoPendingDeliveryPanel);
